/**
 * Canonical display reference for a transaction row (statements, search, receipts).
 * Prefer API `ledger_reference`; else `TRA` + (`group_id` ?? `id`) so split FD
 * transfer legs share the parent withdrawal id when `group_id` is set.
 *
 * @param {object|null|undefined} transaction
 * @returns {string}
 */
export function transactionLedgerReference(transaction) {
	if (!transaction || typeof transaction !== "object") {
		return "";
	}
	const lr = transaction.ledger_reference;
	if (lr != null && String(lr).trim() !== "") {
		return String(lr).trim();
	}
	const idForTra =
		transaction.group_id != null && transaction.group_id !== ""
			? transaction.group_id
			: transaction.id;
	if (idForTra == null || idForTra === "") {
		return "";
	}
	return `TRA${idForTra}`;
}
